import React, {useState} from "react";
import { useSelector } from "react-redux";

import moment from "moment";
import "./myaccount.scss";

import EditAccountModal from "../../components/MyAccount/EditAccountModal";

//TODO: create a component for MyAccount and move it into the MyAccount component folder and use that component here
function MyAccount(props) {
  const user = useSelector((state) => state.appReducer.userDataReducer.data);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openEditModal = () => {
    setModalIsOpen(true);
  };

  const closeEditModal = () => {
    setModalIsOpen(false);
  };
    return (
      <div className="content-container">
        <div className="usa-content-header">
          <div className="usa-header-profile">
            <h1 className="usa-flag-page-header">My Account</h1>
          </div>
        </div>
        <div>
          <div className="usa-account-information">
            <div>
              <div className="usa-table-header-row">
                <h2 className="usa-account-title">ACCOUNT INFORMATION</h2>
              </div>
            </div>
            <div className="usa-account-table-wrapper">
              <div className="usa-account-table-row">
                <span className="usa-account-detail-entry account-name">
                  <h3>NAME</h3>
                  <p>
                    {user.first_name && user.last_name
                      ? user.first_name + " " + user.last_name
                      : "N/A"}
                  </p>
                </span>
                <span className="usa-account-detail-entry account-type">
                  <h3>TYPE OF ACCOUNT</h3>
                  <p>{user.account_type ? user.account_type : "N/A"}</p>
                </span>
                <span
                  onClick={() => {
                    openEditModal();
                  }}
                  className="usa-account-detail-edit"
                >
                  <span>Edit account details</span>
                </span>
              </div>
              <div className="usa-account-table-row">
                <span className="usa-account-detail-entry account-phone">
                  <h3>PHONE NUMBER</h3>
                  <p>{user.phone_number ? user.phone_number : "N/A"}</p>
                </span>
                <span className="usa-account-detail-entry account-ext">
                  <h3>EXTENSION</h3>
                  <p>{user.phone_number_ext ? user.phone_number_ext : "N/A"}</p>
                </span>
              </div>
              <div className="usa-account-table-row">
                <span className="usa-account-detail-entry account-business">
                  <h3>LEGAL BUSINESS NAME</h3>
                  <p>
                    {user.legal_bussiness_name
                      ? user.legal_bussiness_name
                      : "N/A"}
                  </p>
                </span>
                <span className="usa-account-detail-entry account-fein">
                  <h3>
                    FEDERAL EMPLOYER IDENTIFICATION NUMBER (FEIN FROM IRS)
                  </h3>
                  <p>{user.fein ? user.fein : "N/A"}</p>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="usa-account-information">
            <div>
              <div className="usa-table-header-row">
                <h2 className="usa-account-title">LOGIN.GOV CREDENTIALS</h2>
              </div>
            </div>
            <div className="usa-account-table-wrapper">
              <div className="usa-account-table-row">
                <span className="usa-account-detail-entry">
                  <h3>LOGIN.GOV EMAIL ADDRESS</h3>
                  <p>{user.email ? user.email : "N/A"}</p>
                </span>
                <span className="usa-account-detail-entry">
                  <h3>ACCOUNT CREATED</h3>
                  <p>
                    {user.account_created
                      ? moment
                          .unix(user.account_created)
                          .format("MMMM Do YYYY, h:mm a")
                      : "N/A"}
                  </p>
                </span>
                <span
                  className="usa-account-detail-edit"
                  onClick={() => {
                    window.open("https://login.gov");
                  }}
                >
                  <span>Manage login.gov credentials</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <EditAccountModal
          user={user}
          modalIsOpen={modalIsOpen}
          closeEditModal={closeEditModal}
        />
      </div>
    );
  }

export default MyAccount;
